const getOwners = () => {
    const owners = localStorage.getItem("owners")
        ? JSON.parse(localStorage.getItem("owners"))
        : null;

    return owners;
};

const InitialState = {
    owners: getOwners(),
};

const OwnerReducer = (state = InitialState, action) => {
    if (action.type === "Save_Owners") {
        const newState = {
            ...state,
            owners: action.payload,
        };
        localStorage.setItem("owners", JSON.stringify(action.payload));
        return newState;
    }

    else if (action.type === "Remove_User") {
        localStorage.removeItem("owners");
        const newState = {
            owners: null
        };
        return newState;
    }

    return state;
};

export default OwnerReducer;